var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.79688H12",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.7969H12",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.7969H12",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "Mnan nanL11.776 21.6859L8.447 20.0209C8.165 19.8799 7.834 19.8799 7.553 20.0209L4.724 21.4359C4.391 21.6019 4 21.3609 4 20.9889V4.79785C4 4.24585 4.448 3.79785 5 3.79785H19C19.552 3.79785 20 4.24585 20 4.79785V20.9889C20 21.3609 19.609 21.6019 19.276 21.4359L16.447 20.0209C16.165 19.8799 15.834 19.8799 15.553 20.0209L12.224 21.6859C12.083 21.7569 11.917 21.7569 11.776 21.6859Lnan nanLnan nanZ",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.999 7.78797C15.996 7.78797 15.994 7.78997 15.994 7.79297C15.994 7.79597 15.996 7.79797 15.999 7.79797C16.002 7.79797 16.004 7.79597 16.004 7.79297C16.004 7.78997 16.002 7.78797 15.999 7.78797",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.999 11.788C15.996 11.788 15.994 11.79 15.994 11.793C15.994 11.796 15.996 11.798 15.999 11.798C16.002 11.798 16.004 11.796 16.004 11.793C16.004 11.79 16.002 11.788 15.999 11.788",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.999 15.788C15.996 15.788 15.994 15.79 15.994 15.793C15.994 15.796 15.996 15.798 15.999 15.798C16.002 15.798 16.004 15.796 16.004 15.793C16.004 15.79 16.002 15.788 15.999 15.788",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptOrders);
export default __webpack_public_path__ + "static/media/ReceiptOrders.6c12740a4b3e44dc2807a4f0cbb7f010.svg";
export { ForwardRef as ReactComponent };